import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "layout-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = _resolveComponent("a-button");
  const _component_a_table = _resolveComponent("a-table");
  const _component_a_spin = _resolveComponent("a-spin");
  const _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    title: "操作结果",
    bodyStyle: {
      padding: '5px'
    },
    width: 600,
    visible: $setup.IsShow,
    "onUpdate:visible": _cache[0] || (_cache[0] = $event => $setup.IsShow = $event)
  }, {
    footer: _withCtx(() => [_createVNode(_component_a_button, {
      type: "primary",
      onClick: $setup.SubmitForm
    }, {
      default: _withCtx(() => [_createTextVNode("关闭")]),
      _: 1
    }, 8, ["onClick"])]),
    default: _withCtx(() => [_createVNode(_component_a_spin, {
      spinning: $setup.DMConfig.loading
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_table, {
        scroll: {
          y: 340
        },
        size: "small",
        pagination: false,
        columns: $setup.DMConfig.Columns,
        dataSource: $setup.DMConfig.Results
      }, {
        bodyCell: _withCtx(({
          column,
          record,
          index,
          text
        }) => [column.key == 'serial' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode(_toDisplayString(index + 1), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode(_toDisplayString(record[column.dataIndex]), 1)], 64))]),
        _: 1
      }, 8, ["columns", "dataSource"])])]),
      _: 1
    }, 8, ["spinning"])]),
    _: 1
  }, 8, ["visible"]);
}